// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {PageBookmarked} from './page-bookmarked.js'
import {SeqId} from './seq-id.js'
import {SeqMove} from './seq-move.js'
import {SetPageBackground} from './set-page-background.js'

export class ModifyPage {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): ModifyPage {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsModifyPage(bb: flatbuffers.ByteBuffer, obj?: ModifyPage): ModifyPage {
    return (obj || new ModifyPage()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsModifyPage(bb: flatbuffers.ByteBuffer, obj?: ModifyPage): ModifyPage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new ModifyPage()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  pages(index: number, obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new SeqId()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 12, this.bb!) : null
  }

  pagesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  moveTo(obj?: SeqMove): SeqMove | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new SeqMove()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  background(obj?: SetPageBackground): SetPageBackground | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? (obj || new SetPageBackground()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  bookmarked(): PageBookmarked | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : null
  }

  static startModifyPage(builder: flatbuffers.Builder) {
    builder.startObject(4)
  }

  static addPages(builder: flatbuffers.Builder, pagesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, pagesOffset, 0)
  }

  static startPagesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(12, numElems, 4)
  }

  static addMoveTo(builder: flatbuffers.Builder, moveToOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, moveToOffset, 0)
  }

  static addBackground(builder: flatbuffers.Builder, backgroundOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, backgroundOffset, 0)
  }

  static addBookmarked(builder: flatbuffers.Builder, bookmarked: PageBookmarked) {
    builder.addFieldInt8(3, bookmarked, null)
  }

  static endModifyPage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // pages
    return offset
  }
}
